import { render, staticRenderFns } from "./CriminalStepOne.vue?vue&type=template&id=4cb6f164"
import script from "./CriminalStepOne.vue?vue&type=script&lang=js"
export * from "./CriminalStepOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports